import http from '@/support/plugin/axios'

export const

//Ativar || desativar notification push
updatePushSubscriptionByCurrentIdAndCompanyId = (companyId, enableNotification) => {
    const body = {
        enabled: enableNotification
    }

    return http.patch(`companies/${companyId}/contacts/current/push-subscription`, body)
},

//Verificar se assinatura de push notification está habilitada
getPushSubscriptionByCurrentIdAndCompanyId = (companyId) => http.get(`companies/${companyId}/contacts/current/push-subscription`),

//Pegar lista de push notification
getPushNotificationsByCurrentContactIdAndCompanyId = (companyId) => http.get(`companies/${companyId}/contacts/current/push-notifications`)